export default __webpack_public_path__ + "static/media/Tijofi_Ts_100.86aa193e.jpg";